<script lang="ts">
	import './app.component.css';
	import { Router, route } from '@roxi/routify';
	import { routes } from '../../.routify/routes.js';
	import Notification from '../__components__/Notification/Notification.component.svelte';
	import Authentication from '../__components__/Auth/Authentication.component.svelte';
	import { NotificationStore } from '../stores/notification.stores';
	import type { NotificationProps } from '../interfaces/Notification';
	import DiwoNavbar from '../_features_/diwo-navbar/DiwoNavbar.component.svelte';
	import { onMount } from 'svelte';
	import ScrollIndicator from '../__components__/scroll-indicator/ScrollIndicator.component.svelte';

	let notificationProps: NotificationProps = $state();
	let currentPath = $state(typeof window !== 'undefined' ? window.location.pathname : '');

	// $route changes on every client-side navigation, use it to refresh currentPath
	$effect(() => {
		$route;
		if (typeof window !== 'undefined') {
			currentPath = window.location.pathname;
		}
	});

	let isPublicRoute = $derived(
		/^\/meeting-room-manager\/confirm-reservation\/[^/]+\/?$/.test(currentPath)
	);
	let isMrmRoomsListRoute = $derived(
		/^\/meeting-room-manager\/list-room\/building\/[^/]+\/?$/.test(currentPath)
	);
	let isHomeRoute = $derived(currentPath === '/');

	function applyStoredTheme() {
		const htmlElement = document.querySelector('html');
		if (htmlElement?.classList && localStorage.getItem('themeColor')) {
			htmlElement.classList.value = localStorage.getItem('themeColor');
		}
	}

	NotificationStore.subscribe((value) => {
		if (value) {
			notificationProps = {
				description: value.description,
				title: value.title,
				type: value.type,
				show: value.show
			};
		}
	});

	onMount(() => applyStoredTheme());
</script>

<main id="page-content" class:public-route={isPublicRoute}>
	{#if isPublicRoute}
		<Router {routes} />
	{:else}
		<Authentication>
			{#if !isMrmRoomsListRoute}
				<DiwoNavbar />
			{/if}
			<Router {routes} />
		</Authentication>
	{/if}
	<Notification {...notificationProps} />
	{#if !isHomeRoute}
		<ScrollIndicator />
	{/if}
</main>

<style src="./app.component.css"></style>
